import React from 'react'
import { CompositionTableHeaderCell, ResizableHeaderHandle } from './style'

interface ResizableCompositionHeaderCellProps {
  columnKey: string
  onResizeStart: (columnKey: string, clientX: number) => void
  className?: string
  style?: React.CSSProperties
  children: React.ReactNode
}

const ResizableCompositionHeaderCell: React.FC<ResizableCompositionHeaderCellProps> = ({
  columnKey,
  onResizeStart,
  className,
  style,
  children,
}) => {
  return (
    <CompositionTableHeaderCell
      data-col={columnKey}
      className={className}
      style={style}
    >
      {children}
      <ResizableHeaderHandle
        type='button'
        aria-label={`Redimensionar coluna ${children}`}
        onMouseDown={(event) => {
          event.preventDefault()
          event.stopPropagation()
          onResizeStart(columnKey, event.clientX)
        }}
      />
    </CompositionTableHeaderCell>
  )
}

export default ResizableCompositionHeaderCell
